import {useState,useEffect} from 'react'
import {useHistory} from 'react-router-dom'
import ResultsPageSkeletonLoader from './ResultsPageSkeletonLoader'

const ResultsPageBody = ({resValFromUrl}) => {
	const [infoArr,setInfoArr] = useState([])
	const [dataStatus,setDataStatus] = useState('loading')
	const history = useHistory()

	const onSeeMore = (e) => {
		e.preventDefault()
		try{
			const selectedIndex = e.target.getAttribute("data-key")
			history.push('/read/'+infoArr[0].query.search[selectedIndex].title)
		}catch(err){
			alert('Something went wrong.\nPlease check your internet connection or try again later.')
		}
		
	}

	useEffect(()=>{
		const fetchTitle = async (value) => {
			const endPoint = "https://en.wikipedia.org/w/api.php"
			const params = {
				"origin": "*",
				"action": "query",
				"prop" : "extracts",
				"list":"search",
				"srsearch": value,
				"format": "json"
			   };
	
			const esc = encodeURIComponent
			const query = Object.keys(params).map(k => esc(k) + '=' +esc(params[k])).join('&')
			const url = endPoint + "?" + query
			try{
				setDataStatus('loading')
				const res = await fetch(url)
				const data = await res.json()
				if (data.query.search.length !== 0) {
					setInfoArr([data])
				setDataStatus('complete')
				}else{
					setDataStatus('no result')
				}
			  
			}catch(err){
				setInfoArr([])
				console.log(err)
				alert("Something went wrong.\nPlease check your internet connection or try again later.")
				setDataStatus('loading')
			}
		}
		fetchTitle(resValFromUrl)
	},[resValFromUrl])

    return ( 
        <div className="resultspage-body">
        	<div className="resultspage-title">Search results for <b>{resValFromUrl}</b></div>
        	{	
        		dataStatus === 'loading'
        		? <div className="skeleton-loader-cont">
					<div className="skeleton-loader">
						<ResultsPageSkeletonLoader />
						<ResultsPageSkeletonLoader />
						<ResultsPageSkeletonLoader />
						<ResultsPageSkeletonLoader />
					</div>
					<div className="skeleton-shimmer-cont">
					
					</div>
				</div>
        		: dataStatus === 'no result'
        		? <div className="resultspage-title"><h3>No result</h3></div> 
				: infoArr[0].query.search.map((info, index) => (
        		<div onClick={onSeeMore} className="results-card" data-key={index} key={index}>
	            	<h4 href="/" onClick={onSeeMore} data-key={index} className="results-title">{info.title}</h4>
	            	<p className="results-summary" onClick={onSeeMore} data-key={index} dangerouslySetInnerHTML={{__html: info.snippet + "... <button class=\"readmore-btn\">read more</button>"}}></p>
	            	
	            </div>
        	))}
	    </div>
    )
}

export default ResultsPageBody

